import './PharmacyStatus.scss';
import StatusTimeline from '../../../Components/StatusTimeline/StatusTimeline';

const PharmacyStatus = () => {
  // Mock status for now as requested "displayes the staatus only do not change any thing in backend"
  const orderStatus = {
    pharmacy: {
      code: 'order-placed',
      label: 'Order Placed',
      description: 'Your order has been received and is being processed by the pharmacy.',
      date: new Date().toLocaleDateString(),
    },
  };

  return (
    <div className="pharmacy-status-page">
      <div className="container">
        <h1 className="section-title">Track Your Order Status</h1>
        <p className="section-subtitle">Real-time updates on your pharmacy request</p>

        <div className="status-section dash-card">
          <StatusTimeline currentStatus={orderStatus} type={['pharmacy']} />
        </div>

        <div className="info-box dash-card">
          <h3 className="info-title">What happens next?</h3>
          <ul className="info-list">
            <li>Pharmacy reviews your prescription</li>
            <li>Medication is prepared and packaged</li>
            <li>Dispatch for delivery</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PharmacyStatus;
